import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import { useNavigate } from "react-router-dom";
import BookingModel from '../model/BookingModel';

const Reference = () => {
  const [animationData, setAnimationData] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch animation data
    fetch('/success-checkmark.json')
      .then(response => response.json())
      .then(data => setAnimationData(data))
      .catch(error => console.error('Error loading Lottie animation:', error));

    // Fetch the reference number from BookingModel
    const fetchReferenceNumber = async () => {
      try {
       
        setReferenceNumber(sessionStorage.getItem('bookingId'));
      } catch (error) {
        console.error("Error fetching reference number:", error);
      }
    };

    fetchReferenceNumber();
  }, []);

  const onCloseModal = () => {
    navigate('/journey'); // Redirect to home or any desired route
  };

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-reference animated-box">
        <div className="border-top" />
        <div className="border-bottom" />

        {animationData && (
          <div className="success-animation">
            <Lottie options={defaultOptions} height={80} width={80} />
          </div>
        )}

        <h2>BOOKING SUCCESSFUL!</h2>
        <p>YOUR REFERENCE NO:</p>

        {referenceNumber ? (
          <p className="reference-number">{referenceNumber}</p>
        ) : (
          <p>Loading reference number...</p>
        )}

        <button className="got-it-button" onClick={onCloseModal}>Got it!</button>
      </div>
    </div>
  );
};

export default Reference;
